var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{class:{
    'text-body3': _vm.$mq === 'xl' || _vm.$mq === 'l',
    'text-body5': _vm.$mq === 'm',
    'text-body6': _vm.$mq === 's'
  }},[_c('span',{staticClass:"footer_span footer_span-confidential",on:{"click":_vm.openConfidential}},[_vm._v("\n    Политика конфиденциальности\n  ")]),_c('span',{staticClass:"footer_span footer_span-right"},[_vm._v("\n    © "+_vm._s(new Date().getFullYear())+" ООО \"ЕРС\"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }